export const ReconnectType = Object.freeze({
    FACEBOOK: 'Facebook Lead',
    TIKTOK: 'Tiktok Lead Generation',
    ZOHO: 'Zoho CRM',
    SALESFORCE: 'Salesforce',
})